import { render, staticRenderFns } from "./ProductSample.vue?vue&type=template&id=3fbdefdb&scoped=true&"
import script from "./ProductSample.vue?vue&type=script&lang=js&"
export * from "./ProductSample.vue?vue&type=script&lang=js&"
import style0 from "./ProductSample.vue?vue&type=style&index=0&id=3fbdefdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbdefdb",
  null
  
)

export default component.exports